module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAAXNSR0IArs4c6QAAALVJREFUKFOd0r1twlAUQOHPEilDywJkAlKGBkHDCCFZInvESyQwAg2IBkqYgCxAC2VSkGc9S5ZlY+BKr3rnHt2/RHN8RCS9hCYNnld8R+YNszr+kmiIOR5i8i/GWFbJ6kQ9rNAuJR0xwK4sqxJ1sUGnpo3Df1Uv+Cn+l0UheY2nhtnt0UeQZlEUPcZ2npsXmRHb2OapKGrFwY6ulOTYIi7gL1QU3hcmN0pyfIr3IPlEfnR3uqRnrX8YmZnCDJIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/01dailyActive/05up.png
// module id = yFnF
// module chunks = 0